// Monetization 付费相关
import OverallTableCo from '@/pages/dashboard/components/OverallTableCo';
import LtvFilter from '@/pages/dashboard/filterPageComponents/monetization/ltvFilterNew';
import CasualLtvFilter from '@/pages/dashboard/filterPageComponents/monetization/casualLtvFilter';
import SalesOverviewFilter from '@/pages/dashboard/filterPageComponents/monetization/salesOverviewFilter';
import SalesBreakdownCardContext from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesBreakdownCardContext';
import SalesOverviewService from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesOverviewService';
import SalesOverviewTopChartContext from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesOverviewTopChartContext';
import SegmentCo from '@/pages/dashboard/pages/monetization/SalesOverview/components/SegmentCo';
import SalesBreakdownCard from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesBreakdownCard';
import SalesBreakdownCardService from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesBreakdownCardService';
import SalesTrendChart from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesTrendChart';
import LTVLineChartCo from '@/pages/dashboard/pages/monetization/ltv/components/LTVLineChartCo';
import LTVTrackingCo from '@/pages/dashboard/pages/monetization/ltv/components/LTVTrackingCo';
import KeyMetricsCo from '@/pages/dashboard/pages/overview/components/KeyMetricsCo';
// MobileRevenue
import RevenueFilterNewCo from '@/pages/dashboard/filterPageComponents/monetization/revenueFilterNew';
import MonetizationRevenueTrendCo from '@/pages/dashboard/pages/monetization/MonetizationRevenueTrendCo';
import RevenueCo from '@/pages/dashboard/pages/monetization/components/Revenue';
import RevenueMetricsTrendsCo from '@/pages/dashboard/pages/monetization/components/RevenueMetricsTrends';
import PayerAndPayerCo from '@/pages/dashboard/pages/monetization/components/PayerAndPayer';
import RevenueChannelDistributionCo from '@/pages/dashboard/pages/monetization/components/RevenueChannelDistribution';
import RevenueBreakdownCo from '@/pages/dashboard/pages/monetization/components/RevenueBreakdown';
import RevenueTableCo from '@/pages/dashboard/pages/monetization/components/PerformanceTable/index';
// PCRevenue
import PCRevenueCo from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/components/PcRevenue/index';
import PcConsoleRevenueInGameFilter from '@/pages/dashboard/filterPageComponents/monetization/pcConsoleRevenueInGameFilter';
import PcConsoleMonetizationRevenueTrendCo from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/PcConsoleMonetizationRevenueTrendCo';
import PcRevenueChannelDistributionCo from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/components/PcRevenueChannelDistribution/index';
import PcRevenueMetricsTrendsCo from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/components/PcRevenueMetricsTrends/index';
import PcPayerAndPayerCo from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/components/PcPayerAndPayer/index';
import OverallPaymentTableCo from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/components/OverallPaymentTable/index';
import PcConsoleRevenueInGameBreakFilterCo from '@/pages/dashboard/filterPageComponents/monetization/pcConsoleRevenueInGameBreakFilter';
import PcInGameBreakdownCo from '@/pages/dashboard/pages/monetization/pcConsoleRevenue/components/PcInGameBreakdown/index';
import HaveDataDateRange from '@/pages/dashboard/components/HaveDataDateRange';
import IngameRevenueFilter from '@/pages/dashboard/filterPageComponents/monetization/IngameRevenueFilter';
import IngameDlpBreakdownService from '@/pages/dashboard/pages/monetization/ingameRevenue/components/IngameDlpBreakdownService';
import IngameDlpTopChartContext from '@/pages/dashboard/pages/monetization/ingameRevenue/components/IngameDlpTopChartContext';
import IngamePayerOrArpuService from '@/pages/dashboard/pages/monetization/ingameRevenue/components/IngamePayerOrArpuService';
import SalesBreakdownFilter from '@/pages/dashboard/filterPageComponents/monetization/salesBreakdownFilter';
import SalesBreakdownTreeChart from '@/pages/dashboard/pages/monetization/SalesBreakdown/component/SalesBreakdownTreeChart';
import SalesBreakdownTab from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesBreakdownTab';
import SalesBreakdownCardContextTransfer from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesBreakdownCardContextTransfer';
import SalesBreakdownCardServiceTransfer from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesBreakdownCardServiceTransfer';
import SalesOverviewSalesBreakDownServiceTransfer from '@/pages/dashboard/pages/monetization/SalesOverview/components/SalesOverviewSalesBreakDownServiceTransfer';
import PlatformCountryTableTransfer from '@/pages/dashboard/pages/monetization/SalesOverview/components/PlatformCountryTableTransfer';

export default {
  LtvFilter,
  CasualLtvFilter,
  LTVLineChartCo,
  LTVTrackingCo,
  SalesOverviewFilter,
  KeyMetricsCo,
  OverallTableCo,
  SegmentCo,
  SalesOverviewService,
  SalesBreakdownCardContext,
  SalesOverviewTopChartContext,
  SalesTrendChart,
  SalesBreakdownCardService,
  SalesBreakdownCard,
  RevenueFilterNewCo,
  MonetizationRevenueTrendCo,
  RevenueCo,
  RevenueMetricsTrendsCo,
  PayerAndPayerCo,
  RevenueChannelDistributionCo,
  RevenueBreakdownCo,
  RevenueTableCo,
  PCRevenueCo,
  PcConsoleRevenueInGameFilter,
  PcConsoleMonetizationRevenueTrendCo,
  PcRevenueChannelDistributionCo,
  PcRevenueMetricsTrendsCo,
  PcPayerAndPayerCo,
  OverallPaymentTableCo,
  PcConsoleRevenueInGameBreakFilterCo,
  PcInGameBreakdownCo,
  HaveDataDateRange,
  // Sales Breakdown
  SalesBreakdownFilter,
  SalesBreakdownTreeChart,

  // Techland  DL2 In-Game Revenue 页面专项改造
  IngameRevenueFilter,
  IngameDlpBreakdownService,
  IngameDlpTopChartContext,
  IngamePayerOrArpuService,
  SalesBreakdownTab,
  SalesBreakdownCardContextTransfer,
  SalesBreakdownCardServiceTransfer,
  SalesOverviewSalesBreakDownServiceTransfer,
  PlatformCountryTableTransfer,
};
